import { rolesAndPermissionStore } from "@mindmemobile/mm-payment-modules";

/**
 * Gate for fundraiser admin actions (create/save, delete, status, refund, export, cancel).
 * Uses the host's "Manage Money" right, shared with the payment shell. Returns false and opens the
 * "Insufficient Rights" dialog (rendered by FundraiserRoutes) when the user lacks it.
 *
 * Fundraiser mode used to ignore the host's rights entirely (security finding F02). The API is the
 * real authority; this only stops the UI from offering the action.
 */
export function canManageFundraiser(action: string): boolean {
  return rolesAndPermissionStore.hasManagePermission(action);
}
